import Color from "../color/Color";

const AMBIENT_LIGHTING = new Color(0, 0, 0, 0.3);

export default class TileLighting {
    constructor() {
        /**
         * @type {boolean}
         */
        this.everVisibleToCharacter = false;
        /**
         * @type {boolean}
         */
        this.currentlyVisibleToCharacter = false;
    
        /**
         * @private
         * @constant
         * @type {Color}
         */
        this.environmentLighting = new Color(0, 0, 0, 0);
        /**
         * @private
         * @constant
         * @type {Color}
         */
        this.dynamicLighting = new Color(0, 0, 0, 0);
        /**
         * @private
         * @constant
         * @type {Color}
         */
        this.positionalLighting = new Color(0, 0, 0, 0);
            
        /**
         * @private
         * @constant
         * @type {Color}
         */
        this.shadowColor = new Color(0, 0, 0, 0);

        /**
         * @type {boolean}
         */
        this.sunlightFull = false;
        /**
         * @type {number}
         */
        this.sunlightPartial = 0;

    }

    resetLighting() {
        // Do not reset the 'ever visible to character' value.
        this.dynamicLighting.resetFast();
        this.environmentLighting.resetFast();
        this.positionalLighting.resetFast();
        this.currentlyVisibleToCharacter = false;
    }

    resetPositionalLighting() {
        this.positionalLighting.resetFast();
        this.currentlyVisibleToCharacter = false;
    }
    resetEnvironmentLighting() {
        this.environmentLighting.resetFast();
    }
    resetDynamicLighting() {
        this.dynamicLighting.resetFast();
    }

    /**
     * @param {Color} lightColor
     */
    addPositionalLighting(lightColor) {
        this.positionalLighting.add(lightColor);
    }
    /**
     * @param {Color} lightColor
     */
    addEnvironmentLighting(lightColor) {
        this.environmentLighting.add(lightColor);
    }
    /**
     * @param {Color} lightColor
     */
    addDynamicLighting(lightColor) {
        this.dynamicLighting.add(lightColor);
    }

    markTileAsCurrentlyVisible() {
        this.currentlyVisibleToCharacter = true;
        this.everVisibleToCharacter = true;
    }

    markAsSunlightFull() {
        this.sunlightFull = true;

        // If the player can see the tile, then the chararacter can too.
        this.everVisibleToCharacter = true;
    }

    /**
     * @returns {boolean}
     */
    isSunlightPartial() {
        return this.sunlightPartial > 0;
    }

    sunlightPartialIncrement() {
        this.sunlightPartial++;

        // If the player can see the tile, then the chararacter can too.
        this.everVisibleToCharacter = true;
    }

    sunlightPartialDecrement() {
        if (this.sunlightPartial > 0) {
            this.sunlightPartial--;
        }
    }

    /**
     * Calculates the lighting of the tile.
     * @returns {Color}
     */
    calculateShadowColor() {
        // Start off with the ambient color.
        this.shadowColor.set(AMBIENT_LIGHTING);

        // Add color based on whether the tile is currently visible.
        if (this.currentlyVisibleToCharacter) {
            //////////////this.shadowColor.addFast(CURRENTLY_VISIBLE_LIGHTING);

            this.shadowColor.addFast(this.environmentLighting);
            this.shadowColor.addFast(this.dynamicLighting);
            this.shadowColor.addFast(this.positionalLighting);
            this.shadowColor.clamp();
        }

        if (this.sunlightFull) {
            this.shadowColor.setAlpha(1);
        }
        else if (this.sunlightPartial > 0) {
            this.shadowColor.addAlpha(0.3);
        }

        return this.shadowColor;
    }
    
    /**
     * Invoked when the associated tile is reset.
     */
    reset() {
        this.everVisibleToCharacter = false;
        this.currentlyVisibleToCharacter = false;

        this.sunlightFull = false;
        this.sunlightPartial = 0;

    }

}